import {
  Form,
  Input,
  InputNumber,
  Button,
  Row,
  Col,
  notification,
  DatePicker,
} from "antd";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import moment from "moment";

//action
import {
  updatePatientDetail,
  updatePatientDetailResetState,
} from "../../action/updatePatientDetailAction";
import { getPatientDetail } from "../../action/getPatientDetailAction";
//other
import { LayoutContainer, PageContainer } from "../../component/Xcomponent";

const layout = {};

const PatientEditForm = (props) => {
  const patientList_id = props.match.params.id || null;

  const {
    updatePatientDetail,
    updatePatientDetailResetState,
    updatePatientDetailState,
    getPatientDetail,
    getPatientDetailState,
  } = props;
  const [formData, setFormData] = useState({
    id: patientList_id,
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    gender: "",
    address: "",
    city: "",
    pinCode: "",
    state: "",
    weight: "",
    height: "",
    week: "",
    husbandsOrFathersName: "",
    mothersFirstName: "",
    mothersLastName: "",
    fathersFirstName: "",
    fathersLastName: "",
    dob: "",
  });
  const [redirect, setRedirect] = useState([false, ""]);
  const [form] = Form.useForm();
  const [renderForm, setRenderForm] = useState(""); // loading, ideal, error

  //   // Callbacks
  useEffect(() => {
    getPatientDetail({
      id: patientList_id,
    });
  }, []);

  useEffect(() => {
    if (getPatientDetailState.apiState === "success") setRenderForm("ideal");
    if (getPatientDetailState.apiState === "loading") setRenderForm("loading");
    if (getPatientDetailState.apiState === "error") setRenderForm("error");
  }, [getPatientDetailState.apiState]);

  useEffect(() => {
    if (getPatientDetailState.apiState === "success") {
      console.log("getPatientDetailState", getPatientDetailState);
      setFormData({
        ...formData,
        ["firstName"]: getPatientDetailState.data.name?.firstName,
        ["lastName"]: getPatientDetailState.data.name?.lastName,
        ["phone"]: getPatientDetailState.data.phone,
        ["email"]: getPatientDetailState.data.email,
        ["city"]: getPatientDetailState.data.city,
        ["state"]: getPatientDetailState.data.state,
        ["address"]: getPatientDetailState.data.address,
        ["pincode"]: getPatientDetailState.data.pincode,
        ["gender"]: getPatientDetailState.data.gender,
        ["weight"]: getPatientDetailState.data.weight,
        ["height"]: getPatientDetailState.data.height,
        ["week"]: getPatientDetailState.data.week,
        ["pinCode"]: getPatientDetailState.data.pinCode,
        ["interest"]: getPatientDetailState.data.interest,
        ["husbandsOrFathersName"]:
          getPatientDetailState.data.husbandsOrFathersName,
        ["dob"]: getPatientDetailState.data.dob,
        ["mothersFirstName"]: getPatientDetailState.data.mothersName?.firstName,
        ["mothersLastName"]: getPatientDetailState.data.mothersName?.lastName,
        ["fathersFirstName"]: getPatientDetailState.data.fathersName?.firstName,
        ["fathersLastName"]: getPatientDetailState.data.fathersName?.lastName,
        ["status"]: getPatientDetailState.data.status,
      });

      form.setFieldsValue({
        firstName: getPatientDetailState.data.name?.firstName,
        lastName: getPatientDetailState.data.name?.lastName,
        phone: getPatientDetailState.data.phone,
        email: getPatientDetailState.data.email,
        gender: getPatientDetailState.data.gender,
        city: getPatientDetailState.data.city,
        state: getPatientDetailState.data.state,
        address: getPatientDetailState.data.address,
        pinCode: getPatientDetailState.data.pinCode,
        weight: getPatientDetailState.data.weight,
        height: getPatientDetailState.data.height,
        week: getPatientDetailState.data.week,
        interest: getPatientDetailState.data.interest,
        husbandsOrFathersName: getPatientDetailState.data.husbandsOrFathersName,
        dob: getPatientDetailState.data.dob
          ? moment(moment(getPatientDetailState.data.dob), "DD/MM/YYYY")
          : "",
        mothersFirstName: getPatientDetailState.data.mothersName?.firstName,
        mothersLastName: getPatientDetailState.data.mothersName?.lastName,
        fathersFirstName: getPatientDetailState.data.fathersName?.firstName,
        fathersLastName: getPatientDetailState.data.fathersName?.lastName,
        status: getPatientDetailState.data.status,
      });
    }
  }, [getPatientDetailState]);

  useEffect(() => {
    console.log("updatestate", updatePatientDetailState);
    if (updatePatientDetailState.apiState === "success") {
      updatePatientDetailResetState();
      setRedirect([true, "/patient"]);
      notification["success"]({
        message: updatePatientDetailState.message,
        placement: "topRight",
      });
    }
    if (updatePatientDetailState.apiState === "error") {
      updatePatientDetailResetState();
      notification["error"]({
        message: updatePatientDetailState.message,
        placement: "topRight",
      });
    }
  }, [updatePatientDetailState]);

  //Functions
  // console.log("values1");
  const onFinish = () => {
    updatePatientDetail(formData);
  };

  const handleOnChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleDateChange = (date, dateString) => {
    setFormData({ ...formData, [date]: moment(date) });
  };

  return (
    <>
      {redirect[0] && <Redirect to={redirect[1]} />}

      <PageContainer>
        <LayoutContainer className="p-0">
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            style={{ borderRadius: "8px" }}
          >
            <Row gutter={20}>
              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item
                  style={{ borderRadius: "8px" }}
                  name="firstName"
                  label="First Name"
                  rules={[
                    { required: true, message: "Required" },
                    {
                      pattern: "",
                      message: "First Name is not valid",
                    },
                  ]}
                >
                  <Input
                    name="firstName"
                    placeholder="Enter first name"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item
                  style={{ borderRadius: "8px" }}
                  name="lastName"
                  label="Last Name"
                >
                  <Input
                    name="lastName"
                    placeholder="Enter last name"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item
                  style={{ borderRadius: "8px" }}
                  name="phone"
                  label="Phone"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                      type: "regexp",
                      pattern: "^[6-9][0-9]{9}$",
                      message: "Phone number is not valid zeeshan",
                    },
                  ]}
                >
                  <Input
                    name="phone"
                    placeholder="Enter phone"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    { required: true, message: "Required" },
                    {
                      type: "email",
                      message: "Email is not valid",
                    },
                  ]}
                >
                  <Input
                    name="email"
                    placeholder="Enter email"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item
                  name="city"
                  label="City"
                  rules={[
                    { required: true, message: "Required" },
                    {
                      pattern: "",
                      message: "City is not valid",
                    },
                  ]}
                >
                  <Input
                    name="city"
                    placeholder="Enter city"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item
                  name="state"
                  label="State"
                  rules={[
                    { required: true, message: "Required" },
                    {
                      pattern: "",
                      message: "State is not valid",
                    },
                  ]}
                >
                  <Input
                    name="state"
                    placeholder="Enter state"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item
                  name="address"
                  label="Address"
                  rules={[{ required: true, message: "Required" }]}
                >
                  <Input
                    name="address"
                    placeholder="Enter address"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item
                  name="pinCode"
                  label="Pincode"
                  rules={[{ required: true, message: "Required" }]}
                >
                  <Input
                    name="pinCode"
                    placeholder="Enter pinCode"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item
                  name="gender"
                  label="Gender"
                  rules={[
                    { required: true, message: "Required" },
                    {
                      pattern: "",
                      message: "Gender is not valid",
                    },
                  ]}
                >
                  <Input
                    name="gender"
                    placeholder="Enter gender"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item
                  name="weight"
                  label="Weight"
                  rules={[{ required: true, message: "Required" }]}
                >
                  <Input
                    name="weight"
                    placeholder="Enter weight"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item
                  name="height"
                  label="Height"
                  rules={[{ required: true, message: "Required" }]}
                >
                  <Input
                    name="height"
                    placeholder="Enter height"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item
                  name="week"
                  label="Week"
                  rules={[{ required: true, message: "Required" }]}
                >
                  <Input
                    name="week"
                    placeholder="Enter week"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item
                  name="husbandsOrFathersName"
                  label="HusbandsOrFathersName"
                  rules={[{ required: true, message: "Required" }]}
                >
                  <Input
                    name="husbandsOrFathersName"
                    placeholder="Enter husbandsOrFathersName"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item
                  name="dob"
                  label="DOB"
                  rules={[{ required: true, message: "Required" }]}
                >
                  <DatePicker
                    name="dob"
                    placeholder="Birthdate"
                    onChange={(date, dateString) =>
                      handleDateChange("dob", date, dateString)
                    }
                    style={{
                      width: "100%",
                    }}
                    format={"DD/MM/YYYY"}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item
                  name="interest"
                  label="Interest"
                  rules={[{ required: true, message: "Required" }]}
                >
                  <Input
                    name="interest"
                    placeholder="Enter interest"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item name="mothersFirstName" label="Mothers First Name">
                  <Input
                    name="mothersFirstName"
                    placeholder="Enter mothers first name"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item name="mothersLastName" label="Mothers Last Name">
                  <Input
                    name="mothersLastName"
                    placeholder="Enter mothers last name"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item name="fathersFirstName" label="Fathers First Name">
                  <Input
                    name="fathersFirstName"
                    placeholder="Enter fathers first name"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                <Form.Item name="fathersLastName" label="Fathers Last Name">
                  <Input
                    name="fathersLastName"
                    placeholder="Enter fathers last name"
                    onChange={handleOnChange}
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </LayoutContainer>
      </PageContainer>
    </>
  );
};

const mapStateToProps = (state) => ({
  getPatientDetailState: state.getPatientDetail,
  updatePatientDetailState: state.updatePatientDetail,
});

const mapDispatchToProps = (dispatch) => ({
  updatePatientDetail: (params) => dispatch(updatePatientDetail(params)),
  updatePatientDetailResetState: () =>
    dispatch(updatePatientDetailResetState()),
  getPatientDetail: (params) => dispatch(getPatientDetail(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PatientEditForm);

// export default PatientEditForm;
